import { Injectable } from '@angular/core';
import { StoreHistoryEntry } from '../models/store-history-entry';
import { AppConfigService } from './app-config.service';
import { CurrentInfoService } from './current-info.service';
import { InitializationService } from './initialization.service';

@Injectable({
  providedIn: 'root'
})
export class StoreHistoryService 
{
  constructor(
    private initializationservice:InitializationService,
    private currentinfoservice:CurrentInfoService,
    private appconfigservice:AppConfigService,
  ) { }

  placeEntry()
  {
    var currentEntry = new StoreHistoryEntry(this.initializationservice._appName, this.appconfigservice.getPlaceName(), this.currentinfoservice._currentInfo.Icon, Date.now());

    var storeHistoryString =  localStorage.getItem("StoreHistory");

    if(storeHistoryString)
    {
      var storeHistory = <Array<StoreHistoryEntry>>JSON.parse(storeHistoryString);

      var idx = storeHistory.findIndex(x => x.Path === currentEntry.Path)

      if(idx > -1)
        storeHistory.splice(idx, 1, currentEntry);
      else
        storeHistory.push(currentEntry);

      storeHistory.sort((x1, x2) => x2.Timestamp - x1.Timestamp);

      localStorage.setItem("StoreHistory", JSON.stringify(storeHistory));
    }
    else
    {
      var newStoreHistory = new Array<StoreHistoryEntry>(currentEntry);

      localStorage.setItem("StoreHistory", JSON.stringify(newStoreHistory));
    }
  }

  getPlaceHistory()
  {
    var storeHistoryString =  localStorage.getItem("StoreHistory");

    if(storeHistoryString)
    {
      var storeHistory = <Array<StoreHistoryEntry>>JSON.parse(storeHistoryString);

      return storeHistory;
    }

    return new Array<StoreHistoryEntry>();
  }
}
